import { AxiosRequestConfig } from "axios";

import { AdminNoteType } from "@/interfaces/common";
import { GenericAPIResponse } from "@/interfaces/IAuth";
import { axiosInstance, parseResponse, PUBLIC_SITE_URL } from "..";

export const getDailyNoteCategories = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/category`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getDailyNotesTasks = async (
  categoryId?: string,
  opts?: AxiosRequestConfig
) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/task/${categoryId}`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getServiceTypes = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/service-type`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getMedicationRoutes = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/medication-route`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getEthncityRoute = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/ethnicity`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getReligionRoute = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/religion`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getOrientationRoute = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/sexual-orientation`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getTitle = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/profile-title`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getJobRole = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/job-role`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getJobTitle = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/job-role`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getEmploymentType = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/employment-type`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getProfileStatus = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/profile-status`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getServiceType = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/service-type`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getServiceRoster = async (opts?: AxiosRequestConfig) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/dropdowns/roster-employee-type`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getAdminNoteTypes = async (
  opts?: AxiosRequestConfig
): Promise<GenericAPIResponse<AdminNoteType[]>> => {
  try {
    const response = await axiosInstance.get<
      GenericAPIResponse<AdminNoteType[]>
    >(`${PUBLIC_SITE_URL}/admin-note-types`, opts);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getAdminTypes = async (
  opts?: AxiosRequestConfig
): Promise<GenericAPIResponse<AdminNoteType[]>> => {
  try {
    const response = await axiosInstance.get<
      GenericAPIResponse<AdminNoteType[]>
    >(`${PUBLIC_SITE_URL}/admin-note-types`, opts);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getSiteContentByKey = async (
  key: string,
  opts?: AxiosRequestConfig
) => {
  try {
    const response = await axiosInstance.get(
      `${PUBLIC_SITE_URL}/site-content/${key}?t=${new Date().getTime()}`,
      opts
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
